var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{staticClass:"h-100 w-100 iat-choice-button d-flex justify-content-center align-items-center",attrs:{"variant":"bq-green"},on:{"click":_vm.handleClick}},[_c('div',{staticClass:"iat-choice-button__identifier"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }